import uikit from 'nbt-uikit';
import NestedPageSection from './nestedPageSection';

const components = Object.assign(uikit, {
  NestedPageSection
});

export default components;
